import styled, { keyframes } from 'styled-components';

const gradientAnimation = keyframes`
    0% {
        background-position: 0% 50%;
    }
    100% {
        background-position: 200% 50%;
    }
`;

const gradientAnimationColors = [
  '#9EB1FF',
  '#3E63DD',
  '#FF92AD',
  '#E93D82',
  '#29FFDC',
  '#0EB39E',
  '#9EB1FF',
] as const;

export const StyledGradientBar = styled.div<{ $height: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${({ $height }) => $height};
  background: linear-gradient(90deg, ${gradientAnimationColors.join(', ')});
  background-size: 200% 200%;
  animation: ${gradientAnimation} 3s linear infinite;
  animation-play-state: var(--gradient-bar-play-state, running);
  z-index: 2;
  pointer-events: none;
`;

export { gradientAnimation, gradientAnimationColors };

const widthGrow = keyframes`
    0% {
        width: 0%;
    }
    100% {
        width: 100%;
    }
`;

export const ProgressGradientBar = styled(StyledGradientBar)<{
  $durationMs?: number;
}>`
  right: auto;
  width: 0%;
  animation: ${widthGrow}
      ${({ $durationMs }) => ($durationMs ? `${$durationMs}ms` : '10000ms')}
      linear infinite,
    ${gradientAnimation} 3s linear infinite;
  animation-play-state: var(--gradient-bar-play-state, running);
`;
